
export const chatStyles = () => ({
    root: {
       flexGrow: 1,
    },
    'grid-chatlista': {
        borderRight: '2px solid #DDDDDD'
    },
    'grid-chatventana': {
        display: 'flex'
    },
    
});